import { DocumentExtensionType, DocumentType } from '@common/types';
import { useFetchPublishedDocument } from '@hooks/useFetchPublishedDocument';
import * as Styled from './styles';
import { Html } from '@common/pages/ViewHtml/Html';
import React, { useEffect, useState } from 'react';
import { PleaseWaitLoader } from '@components/PleaseWaitLoader';
import styled from 'styled-components';
import { NotifyModal } from '../NotifyModal';
import { serviceDeskEmail } from '@common/constants';

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
`;

export const HtmlDocument = ({
  documentId,
  version,
  documentType,
}: {
  documentId: string;
  version: string;
  documentType?: DocumentType;
}) => {
  const documentTypeForHtml = documentType === DocumentType.Pil ? DocumentType.Epil : documentType;
  const documentTypeForHtmlView = documentType === DocumentType.Smpc ? DocumentType.Smpc : DocumentType.Pil;
  const { data, documentFetching } = useFetchPublishedDocument(
    false,
    documentId,
    version,
    documentTypeForHtml,
    DocumentExtensionType.Html,
  );

  const [showErrorWindow, setShowErrorWindow] = useState(false);
  const [canSeeHtmlWindow, setSeeHtmlWindow] = useState(true);

  const companyMismatchError = (message: string) => {
    const regex = /Document with id: (\d+) isn't assigned to company with id: (\d+)/;
    const match = message.match(regex);
    return match;
  }

  useEffect(() => {
    setShowErrorWindow(data && data.errorMessage !== undefined && companyMismatchError(data.errorMessage));
    setSeeHtmlWindow(data && data.errorMessage === undefined);
  },
    [setShowErrorWindow, data, setSeeHtmlWindow])

  return (
    <Styled.SectionBody>
      {documentFetching ? (
        <LoaderWrap>
          <PleaseWaitLoader />
        </LoaderWrap>)
        : canSeeHtmlWindow ? (
          <Html html={data} docType={documentTypeForHtmlView} />
        ) : (
          <NotifyModal
            isOpen={showErrorWindow ?? false}
            title='This information is not currently available'
            cancelText=''
            onConfirm={() => { setShowErrorWindow(false); }}
            width="35rem">
            <span>
              Please contact Customer Services for assistance&nbsp;
              <a href={`mailto:${serviceDeskEmail}`}>{serviceDeskEmail}</a>
            </span>
          </NotifyModal>
        )}
    </Styled.SectionBody>
  );
};
